import React from "react";

//7x5 squares
// add section to display answer
// symbol
interface GameDisplayProps {
  gameState: string[][];
  currentRow : number;
  currentSquare: number;
}
const GameDisplay = ({ gameState, currentRow, currentSquare }: GameDisplayProps) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "repeat(5, 1fr)",
        boxSizing: "border-box",
        rowGap: "5px",
      }}
    >
      {gameState.map((rowList, i) => (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(7, 1fr)",
            boxSizing: "border-box",
            columnGap: "5px",
          }}
        >
          {rowList.map((item, j) => (
            <div
              style={{
                border: "solid",
                width: "100%",
                padding: "5px",
                backgroundColor: currentRow === i && currentSquare === j ? 'grey' : 'white'
              }}
            >
              {item}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default GameDisplay;
